import { render, staticRenderFns } from "./Grafica2.vue?vue&type=template&id=d0aa4f44&"
import script from "./Grafica2.vue?vue&type=script&lang=js&"
export * from "./Grafica2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports